import type { FC } from 'react';

import { useCms } from '@eneco/cms';
import RichText from '@eneco/components/RichText/RichText';
import { Heading, Text } from '@eneco/sparky';

import type { CorrectionInvoiceFormContent } from '../correction-invoice-form-content.types';

type Props = {
  content: CorrectionInvoiceFormContent;
};

/** Mirrors the legacy `components/Header.tsx`, without the Experience Editor `wrap()`. */
export const Header: FC<Props> = ({ content }) => {
  const { adapter } = useCms();
  const description = adapter.toRichText(content.description);
  return (
    <>
      <Heading as="h2" size={{ initial: 'S', md: 'M' }}>
        {content.Header_title}
      </Heading>
      {description && (
        <Text size={{ initial: 'BodyM', md: 'BodyL' }}>
          <RichText html={description} />
        </Text>
      )}
    </>
  );
};
